import { isMemberTypeOfBoard } from './isMemberTypeOfBoard';

/**
 * Checks if a member has admin access to the board.
 */
export const isAdminOfBoard = (
  member: {
    id: string;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  } & {
    idEnterprisesAdmin?: string[] | null;
  },
  board: {
    memberships: {
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
    organization?:
      | ({ id: string; offering: string } & {
          memberships: ({
            deactivated: boolean;
            idMember: string;
            memberType: 'admin' | 'normal';
            unconfirmed: boolean;
          } & {
            id?: string;
          })[];
        })
      | null
      | undefined;
  },
  implicitAdmin = true,
): boolean => {
  return isMemberTypeOfBoard(
    member,
    board,
    board.organization,
    'admin',
    implicitAdmin,
  );
};
